







































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import MediateApi from '@/api/mediate'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import ImageInfo from '@/views/AiiTasks/ImageInfo.vue'
import Tabs from '@/views/mediate/Tabs.vue'
import DetailHeaderBtns from '@/components/task/DetailHeaderBtns.vue'
import TaskDetailMixins from '@/mixins/taskDetail'
import { dateFormat } from '@/utils/util'
import bus from '@/views/AiiTasks/bus'

@Component({
	name: 'mediateTaskDetail',
	components: {
		PageLayout,
		ImageInfo,
		Tabs,
		DetailHeaderBtns,
	},
})
export default class MediateDetail extends Mixins(TaskDetailMixins) {
	private activeKey: any = '1'
	private once: boolean = false
	private show: any = ''
	private changingCost: boolean = false
	private confirmBoxVisible: boolean = false

	private get prompText() {
		if (this.canCancelMediate) {
			return `注：该状态在12小时内未设置对应的价格发布任务成功，系统默认修改为无需线下调解。`
		} else if (this.task.isFirstHalfMediate) {
			return `注：待审核状态订单在12小时内不处理，系统会在12小时后判断订单自动审核通过且无需进行调解。`
		} else {
			return `注：待确认状态订单在12小时内不处理，系统会在12小时后判断订单自动审核通过且默认调解成功。`
		}
	}

	private get canCancelMediate() {
		// 待终审状态并且审核通过并且已点击需要调解
		if (
			this.order &&
			this.order.orderStatus === '04' &&
			this.order.auditOperationTime &&
			this.tabs.items
		) {
			// 是否已点击需要调解
			let index = this.tabs.items.findIndex((item: any) => {
				return item.title === '调解信息'
			})
			return index >= 0
		} else {
			return false
		}
	}

	private get canChangeMediate() {
		// 待调解和调解中可修改金额
		return (
			this.order &&
			(this.order.orderStatus === '14' || this.order.orderStatus === '15')
		)
	}

	// 点击无需调解
	private cancelMediate() {
		this.$confirm({
			title: '提示',
			content: '是否确认该订单不需要线下调解，如果不需要则任务即默认完成！',
			onOk: () => {},
			onCancel: () => {
				MediateApi.createConciliation(this.$route.params.orderId, '0', {}).then(
					(res: any) => {
						this.getDetail()
						bus.$emit('showEvaluate')
					}
				)
			},
			okText: '需要调解',
			cancelText: '不需要调解',
		})
	}

	// 修改调解金额
	private changeMediate() {
		this.changingCost = true
	}

	private setChangingCost(status: boolean) {
		this.changingCost = status
	}

	// 调解通过确认
	private mediatePass() {
		this.confirmBoxVisible = true
	}

	private hiddenConfirmBox() {
		this.confirmBoxVisible = false
	}

	private chcekPass() {
		this.$confirm({
			title: '提示',
			content: '确认审核通过吗 ?',
			onOk: () => {
				return TaskApi.checkTask({
					orderId: this.$route.params.orderId,
					pass: '1',
				}).then((res: any) => {
					this.getDetail()
					this.$message.success('审核通过成功')
				})
			},
		})
	}

	private onTabsChange(activeKey: string) {
		this.activeKey = activeKey
		window.scrollTo(0, 0)
	}
}
